import type { AnalyticsRouter } from "replo-publisher/src/features/analytics/analytics-router";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: analyticsRouter,
  client: analyticsClient,
  utils: analyticsUtils,
  options: analyticsOptions,
} = createTrpcRouterConfig<AnalyticsRouter>({
  path: "analytics",
  queryClient: getNamespacedQueryClient("analytics"),
});

export { analyticsClient, analyticsRouter, analyticsUtils, analyticsOptions };
